import styled from "styled-components";
import PageTemplate from "../../components/ui/common/template/PageTemplate";
import BoardMemberCard from "../../components/ui/members/BoardMemberCard";
import { getBoardMemberbyName } from "../../context/members/boardscontext";
import PrizeImage from "./../../resources/images/background/intro/prizes.jpg";
const BoardMembersPage = () => {
  return (
    <PageTemplate
      title="경영진 소개"
      large
      image={PrizeImage}
      phrase="현역 관세 스페셜리스트가 관세법인에 최적화된 경영을 선도하고 있습니다."
    >
      <PageDiv>
        <BoardMemberCard type="1" member={getBoardMemberbyName("정운기")} />
        <VPDiv>
          <BoardMemberCard type="3" member={getBoardMemberbyName("황재호")} />
          <BoardMemberCard type="3" member={getBoardMemberbyName("박찬욱")} />
          <BoardMemberCard type="3" member={getBoardMemberbyName("이성욱")} />
          <BoardMemberCard type="2" member={getBoardMemberbyName("유길석")} />
        </VPDiv>
      </PageDiv>
    </PageTemplate>
  );
};
export default BoardMembersPage;
const PageDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-top: 4.5rem;
`;
const VPDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  @media (max-width: 991px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
